<template>
  <div>
    <the-hero-section :title="title" :imgLink="imgLink" />
    <vertical-divider />
    <section id="about-us" class="extra-padding grey lighten-4">
      <v-container>
        <v-row justify="center">
          <v-col cols="11" md="12" class="mx-auto">
            <p class="text-justify font-weight-light">
              Para nosotros lo más importante es que nuestros clientes,
              particulares y empresas, queden completamente satisfechos con los
              servicios que brindamos. En Argecam contamos con personal
              calificado para realizar todas las obras viales.
            </p>
          </v-col>
          <v-col v-for="c in clientes" :key="c.i" cols="6" sm="3" md="3" lg="2">
            <v-skeleton-loader
              :loading="loading"
              transition="scale-transition"
              class="mx-auto"
              max-width="200"
              height="100"
              type="image"
            >
              <v-hover v-slot:default="{ hover }" open-delay="100">
                <v-img
                  :src="require('@/assets/clientes-argecam/' + c.link)"
                  :alt="c.alt"
                  :class="
                    hover ? 'sinfiltro elevation-10' : 'filtro elevation-1'
                  "
                  class="mx-auto rounded-lg white"
                  contain
                  height="100"
                  width="100"
                />
              </v-hover>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section-contact :color="color" />
  </div>
</template>

<script>
export default {
  name: "Clientes",
  components: {
    TheHeroSection: () => import("@/components/TheHeroSection"),
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue"),
    SectionContact: () => import("@/views/Contact/Index.vue")
  },
  data: () => ({
    title: "Nuestros Clientes",
    imgLink: "section-clientes.jpeg",
    clientes: [
      {
        link: "criba-sa.jpg",
        alt: "Logo de Criba S.A."
      },
      {
        link: "cunumi-sa.jpg",
        alt: "Logo de Cunumi S.A."
      },
      {
        link: "dycasa-sa.jpg",
        alt: "Logo de Dycasa S.A."
      },
      {
        link: "esuco-sa.jpg",
        alt: "Logo de Esuco S.A."
      },

      {
        link: "ingeniero-pellegrinet-sa.jpg",
        alt: "Logo Ingeniero Pellegrinet S.A."
      },
      {
        link: "luis-losi-sa.jpg",
        alt: "Logo de Luis Losi S.A."
      },
      {
        link: "reconstruccion-canos-sa.jpg",
        alt: "Logo de Reconstruccion Canos S.A."
      },
      {
        link: "riva-sa.jpg",
        alt: "Logo Riva S.A."
      },
      {
        link: "rovella-carranza-sa.jpg",
        alt: "Logo Rovella Carranza S.A."
      },
      {
        link: "rowing-sa.jpg",
        alt: "Logo de Rowing S.A."
      },
      {
        link: "ses-sa.jpg",
        alt: "Logo de SES S.A."
      },
      {
        link: "sudamericana-sa.jpg",
        alt: "Logo de Sudamericana S.A."
      },
      {
        link: "pentamar-sa.jpg",
        alt: "Logo de Pentamar S.A."
      },
      {
        link: "penedile-sa.jpg",
        alt: "Logo de Penedile S.A."
      },
      {
        link: "vidogar-sa.jpg",
        alt: "Logo de Vidogar S.A."
      },
      {
        link: "sacde-sa.jpg",
        alt: "Logo de Sacde S.A."
      }
    ],
    color: "primary white--text extra-padding"
  })
};
</script>

<style lang="sass" scoped>
.divider
  border: 1px solid red
  left: 0

.filtro
  filter: grayscale(1)
  transition: ease-in .5s

.sinfiltro
  filter: none
  transform: scale(1.2)
  transition: ease-out .5s
  cursor: pointer
</style>
